import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18 21c2.49 0 4.5-2.01 4.5-4.5v-9C22.5 5.01 20.49 3 18 3s-4.5 2.01-4.5 4.5v9c0 2.49 2.01 4.5 4.5 4.5z" fill="#54585D" /><path d="M25.5 16.5c0 4.14-3.36 7.5-7.5 7.5-4.14 0-7.5-3.36-7.5-7.5h-3c0 5.295 3.915 9.645 9 10.38v4.62h3v-4.62c5.085-.735 9-5.085 9-10.38h-3z" fill="#54585D" /></svg>);